import { LumaTheme } from 'embeds/core/styles/getTheme';

export const useStyles = ({
  spacing: { unit },
  palette: {
    common: { white },
    divider,
  },
}: LumaTheme) => ({
  root: {
    height: unit * 6,
    padding: unit,
    backgroundColor: white,
    borderBottom: `1px solid ${divider}`,
  },
  wrapper: {
    width: 600,
  },
});
